import { FeatureFlags } from '#lib/constants/feature-flags.js';
import { talksGalleryPageLoad } from '#lib/websites/talks/pages/TalksGalleryPage/utils/talksGalleryPageLoad/talksGalleryPageLoad.js';
import { talksGalleryPageLoadGql } from '#lib/websites/talks/pages/TalksGalleryPage/utils/talksGalleryPageLoadGql/talksGalleryPageLoadGql.js';

export const load = FeatureFlags.RestPages['/talks/gallery']
	? talksGalleryPageLoad
	: talksGalleryPageLoadGql;
